import moment from "moment";
import {
  calcKcalByAttrId,
  countNutrientsByAttrId,
  emptyMealStudyDrug,
} from "../../../../helpers/mealsHelper";
import {
  dailyTargetIds,
  getBaseDateFormat,
} from "../../../../modules/constants";
import { DIET_DIARY_TYPE_NAME } from "../../../smart/DietDiary/DietDiary.constants";

export const calcStudyDrugPercentage = (studyDrugDaiy, totalCalories) => {
  const studyDrugKcal = calcKcalByAttrId(
    studyDrugDaiy,
    dailyTargetIds.MEDIUM_CHAIN_FATS_ATTR_ID
  );
  let totalPercentage = 0;
  if (!!studyDrugKcal && !!totalCalories) {
    totalPercentage = (studyDrugKcal * 100) / totalCalories;
  }
  return totalPercentage;
};

const aggregatorByDay = (accumulator, item) => {
  return {
    date: `${item?.date}`,
    studyDrug: (accumulator?.studyDrug || 0) + item.nutrients,
    studyDrugQty: (accumulator?.studyDrugQty || 0) + item.qty,
    completed: item?.completed,
    sickDay: item?.sickDay,
    totalCalories: (accumulator?.totalCalories || 0) + item.totalCalories,
    dayTotal: true,
  };
};

const aggregateByDay = (data) => {
  const dataByDay = data
    .filter((meal) => meal.date === data[data.length - 1].date)
    .reduce(aggregatorByDay, {});

  return dataByDay;
};

export const getDataToToleratedDoseStudyDrugReport = (entries, allDates) => {
  let totalsData = { completedDays: 0, sickDays: 0 };
  const mealData = [];
  entries?.forEach((dailyEntry) => {
    const { date, completed, sickDay } = dailyEntry;

    if (completed) {
      totalsData.completedDays += 1;
    }

    if (sickDay) {
      totalsData.sickDays += 1;
    }

    if ((sickDay || completed) && !dailyEntry.meals.length) {
      dailyEntry.meals.push({
        mealJson: emptyMealStudyDrug,
      });
    }
    dailyEntry.meals.forEach((meal) => {
      const mealParsed = JSON.parse(meal.mealJson);
      mealParsed.items.forEach((item) => {
        const mealDate = moment(date).format(getBaseDateFormat());
        if (
          mealData.length > 0 &&
          mealData[mealData.length - 1].date !== mealDate
        ) {
          mealData.push(aggregateByDay(mealData));
        }
        const newItem = {
          date: mealDate,
          completed: completed ? "Yes" : "No",
          sickDay: sickDay ? "Yes" : "No",
          qty:
            item?.title === DIET_DIARY_TYPE_NAME.STUDY_DRUG &&
            Number(item?.qty || 0),
          nutrients:
            item?.title === DIET_DIARY_TYPE_NAME.STUDY_DRUG &&
            item?.selectedMeasure
              ? countNutrientsByAttrId(
                  dailyTargetIds.MEDIUM_CHAIN_FATS_ATTR_ID,
                  [item]
                )
              : 0,
          totalCalories: item?.selectedMeasure
            ? countNutrientsByAttrId(dailyTargetIds.CALORIES_ATTR_ID, [item])
            : 0,
        };
        mealData.push(newItem);
      });
    });
  });
  mealData.push(aggregateByDay(mealData));
  const finalData = mealData.filter((meal) => meal.dayTotal);

  const emptyData = [];
  allDates.forEach(function (date) {
    const emptyDayData = {
      completed: "No",
      dayTotal: true,
      sickDay: "No",
      studyDrug: 0,
      studyDrugQty: 0,
      date: moment(date).format(getBaseDateFormat()),
      totalCalories: 0,
    };
    emptyData.push(emptyDayData);
  });

  // After getting all the dates between startDate and endDate, fill each day with defaultData
  // and then replace each non empty day with respective meal data by date
  const dateRangeData = Object.values(
    [].concat(emptyData, finalData).reduce((r, c) => {
      r[c.date] = Object.assign(r[c.date] || {}, c);
      return r;
    }, {})
  );

  return { dateRangeData, totalsData };
};

export const getPastDate = (days) => {
  return moment().subtract(days, "days").startOf("day");
};
